import AntArray from './AntArray';

export default {
    getKeys: function (obj) {
        let ar = [];
        if (typeof obj === 'object' && obj && Object.keys(obj).length > 0) {
            ar = Object.keys(obj)
                .map((k) => {
                    let kValue = obj[k];
                    let kKeys = [k];
                    if ((k === 'dataField' || k === 'secondField') && typeof kValue === 'string') kKeys = [kValue];
                    if (k === 'fields' && kValue instanceof Array) kKeys = kValue;
                    if (k === 'key' && typeof kValue === 'string') kKeys = [kValue];

                    return [...kKeys, ...this.getKeys(kValue)];
                })
                .flat();
        } else if (obj instanceof Array) {
            ar.push(...obj.map((o) => this.getKeys(o)).flat());
        } else if (typeof obj === 'string') ar.push(obj);
        ar = ar.flat();
        ar = AntArray.distinct(ar);
        return ar;
    },
    isDeepEqual: function (obj1, obj2) {
        if (obj1 === obj2) return true;
        if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
        let keys1 = Object.keys(obj1);
        let keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;
        for (let key of keys1) {
            if (!Object.prototype.hasOwnProperty.call(obj2, key) || !this.isDeepEqual(obj1[key], obj2[key])) return false;
        }
        return true;
    }
};
